import { createSelector } from '@reduxjs/toolkit';

import DocumentListFetchRange from '@app/store/documentsExport/DocumentListFetchRange';
import { DocumentListItemType } from '@app/store/transport-layer/document/documents';
import { RootState } from '@app/store/types';

export const getDocumentsExportState = (state: RootState) => state.documentsExport;

export const getAllIds = (state: RootState) => getDocumentsExportState(state).allIds;
export const getAssigned = (state: RootState) => getDocumentsExportState(state).assigned;
export const getById = (state: RootState) => getDocumentsExportState(state).byId;
export const getLimit = (state: RootState) => getDocumentsExportState(state).limit;
export const getErrorMessage = (state: RootState) => getDocumentsExportState(state).errorMessage;
export const getLabelId = (state: RootState) => getDocumentsExportState(state).labelId;
export const getListFetchRange = (state: RootState): DocumentListFetchRange | null =>
  getDocumentsExportState(state).listFetchRange;
export const getLoadingStatus = (state: RootState) => getDocumentsExportState(state).loadingStatus;
export const getMaxPage = (state: RootState) => getDocumentsExportState(state).maxPage;
export const getOffset = (state: RootState) => getDocumentsExportState(state).offset;
export const getStart = (state: RootState) => getListFetchRange(state)?.start ?? 1;
export const getStartIndex = (state: RootState) =>
  getStart(state) - 1 < 0 ? 0 : getStart(state) - 1;
export const getTotalDocumentsCount = (state: RootState) =>
  getDocumentsExportState(state).totalDocumentsCount;

export const getTotalDocumentsCountLoadingStatus = (state: RootState) =>
  getDocumentsExportState(state).totalDocumentsCountLoadingStatus;

export const getDocumentList = (state: RootState): DocumentListItemType[] =>
  Object.values(getById(state)) ?? [];

export const getDocumentCount = createSelector(getById, (byId) => {
  const list = Object.values(byId);
  return list.length;
});
